import React from 'react'
import { setCookie, getCookie } from './cookie'

export const arrayShuffle = function(o) {
    for (var j, x, i = o.length; i; j = parseInt(Math.random() * i, 10), x = o[--i], o[i] = o[j], o[j] = x);
    return o
}

export const Image = function(src, errSrc, alt) {
    return <img src={src} onError={e => itemImageError(e, errSrc)} alt={alt} />
}

export const getImage = function(cid, item_id, alt, size, seq) {
    const dir = Math.ceil(parseInt(item_id, 10) / 1000) * 1000
    let imgUrl = `${process.env.REACT_APP_CDN_IMG}/img_shopping/img_goods/img_` + dir + '/img_' + item_id

    let callCateID = cid.toString()
    if (cid.toString().substr(0, 1) === '2') {
        callCateID = '2010000000'
    }
    let noImgUrl = `${process.env.REACT_APP_CDN_IMG}/img_shopping/img_goods/img_no/` + callCateID

    return itemImage({ imgUrl: imgUrl, noImgUrl: noImgUrl }, alt, size, seq)
}

export const itemImage = function(thumbnail, alt, size, seq, cls) {
    alt = alt ? alt : ''
    let src = thumbnail.imgUrl
    let err = thumbnail.noImgUrl

    if (src === undefined) src = thumbnail.imgPath
    if (err === undefined) err = thumbnail.errorPath

    let getSeq = seq && seq !== '0' && seq !== 0 ? '.' + seq : ''

    if (size === undefined || size === '') {
        src = src + '/200' + getSeq + '.jpg'
        err = err + '_500.png'
    } else {
        src = src + '/' + size + getSeq + '.jpg'
        err = err + '_500.png'
    }
    // console.log(src);
    // console.log(err);
    return <img src={src} onError={e => itemImageError(e, err)} alt={alt} className={cls} />
}

export const itemImageError = function(e, err) {
    if (e.target.src.indexOf(err) === -1) {
        // e.target.src = err
        e.target.src = `${process.env.REACT_APP_CDN_IMG}/img_shopping/img_goods/img_no/no_item_img.jpg`
    }
}

export const getImagePath = function(cid, item_id) {
    const dir = Math.ceil(parseInt(item_id, 10) / 1000) * 1000
    return `${process.env.REACT_APP_CDN_IMG}/img_shopping/img_goods/img_` + dir + '/img_' + item_id + '/'
}

export const numberFormat = function(num, m) {
    let numStr = '0'
    if (num) {
        num = parseInt(num, 10)
        numStr = num.toLocaleString()
    }
    if (m) {
        numStr = num.replace(/([^\d]*)/gi, '')
        numStr = parseInt(num.replace(/(,*)/gi, ''), 10)
        if (isNaN(numStr)) numStr = 0
    }
    return numStr
}

export const getRandom = function(min, max, opt) {
    if (opt === 'min') {
        // min (포함) 과 max (불포함) 사이의 난수를 반환
        return parseInt(Math.random() * (max - min) + min, 10)
    } else if (opt === 'max') {
        // min (포함) 과 max (불포함) 사이의 임의 정수를 반환
        return parseInt(Math.floor(Math.random() * (max - min)) + min, 10)
    }

    // min (포함) 과 max (포함) 사이의 임의 정수를 반환
    return parseInt(Math.floor(Math.random() * (max - min + 1)) + min, 10)
}

export const Offset = function(selector, opt) {
    if (opt === 'all') {
        let dqs = document.querySelectorAll(selector)
        // console.log(dqs)
        let rst = []
        try {
            dqs.forEach(function(v) {
                // console.log(v)
                try {
                    let rect = v.getBoundingClientRect()
                    let scrollLeft = window.pageXOffset || document.documentElement.scrollLeft
                    let scrollTop = window.pageYOffset || document.documentElement.scrollTop
                    let offset = {
                        top: rect.top + scrollTop,
                        left: rect.left + scrollLeft,
                        width: rect.width,
                        height: rect.height,
                    }
                    rst.push(offset)
                } catch (e) {
                    rst.push(0)
                }
            })
            return rst
        } catch (e) {
            return []
        }
    } else {
        let dqs = document.querySelector(selector)
        try {
            let rect = dqs.getBoundingClientRect()
            let scrollLeft = window.pageXOffset || document.documentElement.scrollLeft
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop
            let offset = {
                top: rect.top + scrollTop,
                left: rect.left + scrollLeft,
                width: rect.width,
                height: rect.height,
            }
            return offset
        } catch (e) {
            return 0
        }
    }
}

export const scrollTo = function(selector, opt = {}, dom = window, behavior = true) {
    let select = Offset(selector)
    if (select === 0) return 0
    var isSmoothScrollSupported = 'scrollBehavior' in document.documentElement.style
    let options = {
        behavior: behavior ? 'smooth' : 'auto',
        top: select.top,
        left: 0,
    }
    if (opt.top) options.top = options.top + opt.top
    // if (opt.top) option.top = option.top+opt.top
    if (isSmoothScrollSupported) {
        dom.scrollTo(options)
    } else {
        dom.scrollTo(options.left, options.top)
    }
}

export const estimate = {
    addEstimateItem(itemId, items, count) {
        if (!items) items = getCookie('item_est')
        count = count || 1

        let estimateItems = items ? items.split(',') : []
        let deleteIdx = estimateItems.indexOf(itemId.toString())
        if (deleteIdx !== -1) {
            if (count === 1) {
                count = getCookie('cnt_' + itemId.toString())
                count = parseInt(count, 10) + 1
            }
            setCookie('cnt_' + itemId.toString(), count, 9 * 24 * 60 * 60, '/', `.pping.${process.env.REACT_APP_TLD}`)
        } else {
            estimateItems.push(itemId)
            setCookie('item_est', estimateItems.toString(), 9 * 24 * 60 * 60, '/', `.pping.${process.env.REACT_APP_TLD}`)
            setCookie('cnt_' + itemId.toString(), count, 9 * 24 * 60 * 60, '/', `.pping.${process.env.REACT_APP_TLD}`)
        }
        return estimateItems.toString()
    },

    addEstimateItems(itemId) {
        let estimates = getCookie('item_est')

        if (typeof itemId === 'object') {
            itemId.map(v => {
                estimates = this.addEstimateItem(v, estimates)
                return estimates
            })
            return estimates
        } else {
            return this.addEstimateItem(itemId, estimates)
        }
    },

    reEstimateItem(itemId, count) {
        if (typeof itemId === 'object') {
            itemId.map(v => {
                setCookie('cnt_' + v.toString(), count, 9 * 24 * 60 * 60, '/', `.pping.${process.env.REACT_APP_TLD}`)
                return true
            })
        } else {
            setCookie('cnt_' + itemId.toString(), count, 9 * 24 * 60 * 60, '/', `.pping.${process.env.REACT_APP_TLD}`)
        }
    },

    delEstimateItems(itemId) {
        let estimates = getCookie('item_est')

        if (typeof itemId === 'object') {
            itemId.map(v => {
                estimates = this.delEsitmateItem(estimates, v)
                return true
            })
            return estimates
        } else {
            return this.delEsitmateItem(estimates, itemId)
        }
    },

    delEstimateService(itemId) {
        let estimates = getCookie('item_est')

        let cnt_76709 = parseInt(getCookie('cnt_76709'), 10) // 전문가 조립 서비스
        let cnt_1154496 = parseInt(getCookie('cnt_1154496'), 10) // 조립 + AS
        let cnt_1099785 = parseInt(getCookie('cnt_1099785'), 10) // 박스 동봉 서비스

        // console.log(cnt_76709, cnt_1154496, cnt_1099785)
        if (itemId.toString() === '76709') {
            if (cnt_76709 < cnt_1099785 && cnt_1154496 < cnt_1099785) {
                this.reEstimateItem('1099785', cnt_1099785 - cnt_76709)
                estimates = this.delEstimateItems('76709')
            } else {
                estimates = this.delEstimateItems(['76709', '1099785'])
            }
        } else if (itemId.toString() === '1154496') {
            if (cnt_1154496 < cnt_1099785 && cnt_76709 < cnt_1099785) {
                this.reEstimateItem('1099785', cnt_1099785 - cnt_1154496)
                estimates = this.delEstimateItems('1154496')
            } else {
                estimates = this.delEstimateItems(['1154496', '1099785'])
            }
        }
        return estimates
    },

    delEsitmateItem(estimateItems, itemId) {
        let estimates = estimateItems ? estimateItems.split(',') : []

        let deleteIdx = estimates.indexOf(itemId.toString())
        if (deleteIdx !== -1) {
            estimates.splice(deleteIdx, 1)
            setCookie('item_est', estimates.toString(), 9 * 24 * 60 * 60, '/', `.pping.${process.env.REACT_APP_TLD}`)
            setCookie('cnt_' + itemId.toString(), null, 9 * 24 * 60 * 60, '/', `.pping.${process.env.REACT_APP_TLD}`)
        }
        return estimates.toString()
    },

    delEstimateAllItems() {
        const items = getCookie('item_est')

        let estimateItems = items ? items.split(',') : []

        setCookie('item_est', null, 9 * 24 * 60 * 60, '/', `.pping.${process.env.REACT_APP_TLD}`)
        estimateItems.map(v => {
            setCookie('cnt_' + v.toString(), null, 9 * 24 * 60 * 60, '/', `.pping.${process.env.REACT_APP_TLD}`)
            return true
        })
        return true
    },

    listCompareItems(items) {
        if (!items) {
            items = getCookie('item_compare')
        }

        let compareItems = this.dataToArray(items, '||')

        let compareDatas = compareItems.map((v, _i) => {
            return this.dataToArray(v, '^')
        })
        return compareDatas
    },

    addCompareItems(itemId, compareData) {
        const items = getCookie('item_compare')

        let compareItems = this.dataToArray(items, '||')

        let checkIdx = -1
        compareItems.map((v, i) => {
            const compareData = this.dataToArray(v, '^')
            if (compareData[0] === itemId.toString()) {
                checkIdx = i
            }
            return compareData
        })

        if (checkIdx !== -1) {
            compareItems = this.delCompareItems(itemId)
            return compareItems
        } else {
            compareItems.push(compareData.toString())
            setCookie('item_compare', compareItems.join('||'), 0, '/', `.pping.${process.env.REACT_APP_TLD}`)
            return this.listCompareItems(compareItems.join('||'))
        }
    },

    delCompareItems(itemId) {
        const items = getCookie('item_compare')

        let compareItems = this.dataToArray(items, '||')
        let deleteIdx = -1
        compareItems.map((v, i) => {
            const compareData = this.dataToArray(v, '^')
            if (compareData[0] === itemId.toString()) deleteIdx = i
            return compareData
        })

        if (deleteIdx !== -1) {
            compareItems.splice(deleteIdx, 1)
            setCookie('item_compare', compareItems.join('||'), 9 * 24 * 60 * 60, '/', `.pping.${process.env.REACT_APP_TLD}`)
        }
        return this.listCompareItems(compareItems.join('||'))
    },

    delCompareAllItems() {
        setCookie('item_compare', null, 9 * 24 * 60 * 60, '/', `.pping.${process.env.REACT_APP_TLD}`)
        return {}
    },

    dataToArray(d, prefix) {
        if (d) {
            if (prefix) {
                return d.split(prefix)
            }
            return d.split(',')
        }
        return []
    },
}



// WEBPACK FOOTER //
// ./src/common/util/util.js